export interface StudiesInformListItemDTO {
  studyDiagnosticId: number
  patientId: number
  patientFullName: string
  patientFullDoc: string
  studyTypeId: number
  studyTypeLabel: string
  requestedDate: string
  serviceDate: string
  healthEntityName: string
  professionalFullName: string
  providerName: string
  presumptiveDiagnostic: string
  observations: string | null
  externalId: string | null
  location: string | null
  status: string | null
  cancelReason: string | null
}



export const defaultStudiesInformListItemDTO: StudiesInformListItemDTO = {
  studyDiagnosticId: 0,
  patientId: 0,
  patientFullName: '',
  patientFullDoc: '',
  studyTypeId: 0,
  studyTypeLabel: '',
  requestedDate: '',
  serviceDate: '',
  healthEntityName: '',
  professionalFullName: '',
  providerName: '',
  presumptiveDiagnostic: '',
  observations: null,
  externalId: null,
  location: null,
  status: null,
  cancelReason: null,
}

export interface StudyInformDeterminationDTO {
  determinationId: number
  description: string
  numeric: boolean
  unit: string | null
  value: string
}

export interface StudiesInformDetailsDTO {
  studyDiagnosticId: number
  patientId: number
  patientFullName: string
  patientFullDoc: string
  studyTypeId: number
  studyTypeLabel: string
  requestedDate: string
  serviceDate: string
  healthEntityName: string
  professionalFullName: string
  providerName: string
  dicomViewerUrl: string | null
  requiresImages: boolean
  presumptiveDiagnostic: string
  observations: string | null
  description: string | null
  result: string | null
  externalId: string | null
  age: number
  phonenumber: string | null
	email : string | null
	coverage : string | null
	plan : string | null
	benefitnumber : string | null
  status: string | null
  cancelReason: string | null
  determinations: StudyInformDeterminationDTO[]
}

function parseDateToISO(value: string | null | undefined): string | null {
  if (!value) return null
  // Convert dd/MM/yyyy HH:mm[:ss] → yyyy-MM-ddTHH:mm:ss
  const matchDT = /^(\d{2})\/(\d{2})\/(\d{4})[T ](\d{2}):(\d{2})(?::(\d{2}))?/.exec(value)
  if (matchDT) {
    const [, day, month, year, hour, minute, second = '00'] = matchDT
    return `${year}-${month}-${day}T${hour}:${minute}:${second}`
  }
  // Convert dd/MM/yyyy → yyyy-MM-dd
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value)
  if (match) return `${match[3]}-${match[2]}-${match[1]}`
  return value
}

export function studiesInformDetailsDTOFromResponse(data: any): StudiesInformDetailsDTO {
  return {
    ...data,
    requestedDate: parseDateToISO(data.requestedDate) ?? data.requestedDate,
    serviceDate: parseDateToISO(data.serviceDate) ?? data.serviceDate,
    phonenumber: data.phonenumber ?? data.phoneNumber ?? null,
    coverage: data.coveragePlanName ?? null,
    benefitnumber: data.benefitnumber ?? data.benefitNumber ?? null,
    determinations: data.determinations ?? [],
    requiresImages: data.requiresImages === true,
  }
}

export const defaultStudiesInformDetailsDTO: StudiesInformDetailsDTO = {
  studyDiagnosticId: 0,
  patientId: 0,
  patientFullName: '',
  patientFullDoc: '',
  studyTypeId: 0,
  studyTypeLabel: '',
  requestedDate: '',
  serviceDate: '',
  healthEntityName: '',
  professionalFullName: '',
  providerName: '',
  dicomViewerUrl: null,
  requiresImages: false,
  presumptiveDiagnostic: '',
  observations: null,
  description: null,
  result: null,
  externalId: null,
  age: 0,
  phonenumber: null,
	email : null,
	coverage : null,
	plan : null,
	benefitnumber : null,
  status: null,
  cancelReason: null,
  determinations: [],
}